import React, { useState } from 'react'

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { createUser, editUser } from '../../api/AdminRequest';

function CreateUser({ edit }) {

  const { Title } = Typography;

  const navigate = useNavigate();
  const { state } = useLocation();
  const [userData] = useState(edit ? state.drawerData : '');
  const [phone, setPhone] = useState(edit ? '' + state.drawerData.phone : '971');
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    values.phone = phone;
    try {
      const { data } = edit

        ? await editUser(userData._id, values)
        : await createUser(values);
        console.log("api sent and received")

      if (data.success) {
        toast.success('New User Created', {
          position: "top-right",
          autoClose: 3000,
          theme: "dark",
        });
      } else if (data.update) {
        toast.success('Updated Successfully', {
          position: "top-right",
          autoClose: 3000,
          theme: "dark",
        });
      }
      setTimeout(() => navigate('/active-users'), 3000);
    } catch (error) {
      const errorMessage = error.response.data.message? error.response.data.message: "something went wrong"
      toast(error.response.data.message);
    }
  };

  const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const UserIcon = () => (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth={2}
      strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
      {edit ? (
        <>
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </>
      ) : (
        <>
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="22" y1="11" x2="16" y2="11" />
        </>
      )}
    </svg>
  );

  const FieldLabel = ({ children }) => (
    <span className="block text-sm font-semibold text-slate-600 mb-1.5">
      {children}
    </span>
  );

  const SectionLabel = ({ children }) => (
    <div className="flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-slate-400 mb-4 pb-3 border-b border-slate-100">
      <span className="w-1.5 h-1.5 rounded-full bg-blue-800 flex-shrink-0" />
      {children}
    </div>
  );

  return (
    <>
      {/* Minimal overrides only for Ant Design internals that Tailwind can't reach */}
      <style>{`
        .cu-root { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
        .cu-heading { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; font-weight: 800; }
        .cu-root .ant-input,
        .cu-root .ant-input-affix-wrapper {
          border-radius: 10px !important; border: 1.5px solid #e2e8f0 !important;
          background: #f8fafc !important; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
          font-size: 14px !important; padding: 10px 14px !important;
        }
        .cu-root .ant-input-affix-wrapper { padding: 0 14px !important; }
        .cu-root .ant-input-affix-wrapper .ant-input {
          border: none !important; box-shadow: none !important;
          background: transparent !important; padding: 10px 0 !important;
        }
        .cu-root .ant-input:focus,
        .cu-root .ant-input-affix-wrapper-focused {
          border-color: #1e3a8a !important;
          box-shadow: 0 0 0 3px rgba(30,58,138,0.1) !important;
          background: #fff !important;
        }
        .cu-root .ant-select-selector {
          border-radius: 10px !important; border: 1.5px solid #e2e8f0 !important;
          background: #f8fafc !important; min-height: 42px !important;
          display: flex !important; align-items: center !important;
          padding: 0 14px !important; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
          font-size: 14px !important;
        }
        .cu-root .ant-select-focused .ant-select-selector {
          border-color: #1e3a8a !important;
          box-shadow: 0 0 0 3px rgba(30,58,138,0.1) !important;
        }
        .cu-root .ant-form-item { margin-bottom: 0 !important; }
        .cu-root .react-tel-input .form-control {
          border-radius: 10px !important; border: 1.5px solid #e2e8f0 !important;
          height: 42px !important; width: 100% !important;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important; font-size: 14px !important;
          background: #f8fafc !important; padding-left: 52px !important; color: #0f172a !important;
        }
        .cu-root .react-tel-input .form-control:focus {
          border-color: #1e3a8a !important;
          box-shadow: 0 0 0 3px rgba(30,58,138,0.1) !important; background: #fff !important;
        }
        .cu-root .react-tel-input .flag-dropdown {
          border-radius: 10px 0 0 10px !important; border: 1.5px solid #e2e8f0 !important;
          border-right: none !important; background: #f1f5f9 !important;
        }
      `}</style>

      <div className="cu-root min-h-screen flex flex-col justify-center items-center px-8 py-10">

        {/* ── Page Header ── */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-blue-800 flex items-center justify-center shadow-lg shadow-blue-900/25 flex-shrink-0">
            <UserIcon />
          </div>
          <div>
            <h1 className=" text-2xl font-semibold text-slate-900  leading-none mb-1">
              {edit ? 'Edit User' : 'Create User'}
            </h1>
            <p className="text-sm text-slate-400 font-normal m-0">
              {edit
                ? 'Update the details for this user account.'
                : 'Fill in the details below to register a new user.'}
            </p>
          </div>
        </div>

        {/* ── Card ── */}
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-8 max-w-7xl">
          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            initialValues={{
              name: userData.name,
              email: userData.email,
              userType: userData.userType,
            }}
            scrollToFirstError
            className='w-full'
          >

            {/* Section: Account Info */}
            <SectionLabel>Account Information</SectionLabel>

            <div className="grid grid-cols-2 w-full gap-5 mb-5">

              <div className="flex flex-col">
                <FieldLabel>Full Name</FieldLabel>
                <Form.Item
                  name="name"
                  rules={[{ required: true, message: 'Please input your name!', whitespace: true }]}
                >
                  <Input placeholder="e.g. Jane Doe" />
                </Form.Item>
              </div>

              <div className="flex flex-col">
                <FieldLabel>Email Address</FieldLabel>
                <Form.Item
                  name="email"
                  rules={[
                    { type: 'email', message: 'The input is not valid E-mail!' },
                    { required: true, message: 'Please input your E-mail!' },
                  ]}
                >
                  <Input placeholder="e.g. jane@example.com" />
                </Form.Item>
              </div>

              {/* <div className="flex flex-col">
                <FieldLabel>Phone Number</FieldLabel>
                <PhoneInput
                  country={"eg"}
                  enableSearch={true}
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                />
              </div> */}

              <div className="flex flex-col">
                <FieldLabel>Phone Number</FieldLabel>
                <Form.Item
                  name="phone"
                  rules={[
                    { required: true, message: 'Please input your phone number!' },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        // Ensure value is a string before processing
                        const phoneStr = typeof value === 'string' ? value : String(value || '');
                        if (!phoneStr) return Promise.resolve();

                        // Extract only digits from the phone value
                        const digitsOnly = phoneStr.replace(/\D/g, '');
                        // Valid phone numbers should have at least 8 digits
                        if (digitsOnly.length < 8) {
                          return Promise.reject(
                            new Error('Phone number is invalid!')
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  hasFeedback
                >
                  <PhoneInput
                    country={"eg"}
                    enableSearch={true}
                    value={phone}
                    onChange={(value) => {
                      const phoneStr = String(value || '');
                      setPhone(phoneStr);
                      form.setFieldValue('phone', phoneStr);
                    }}
                  />
                </Form.Item>
              </div>

              <div className="flex flex-col">
                <FieldLabel>User Type</FieldLabel>
                <Form.Item
                  name="userType"
                  rules={[{ required: true, message: 'Please select a User Type!' }]}
                >
                  <Select size="large" placeholder="Select type">
                    <Select.Option value="demo">normal</Select.Option>
                  </Select>
                </Form.Item>
              </div>

            </div>

            {/* Section: Security — create mode only */}
            {!edit && (
              <>
                <div className="border-t border-slate-100 my-6" />
                <SectionLabel>Security</SectionLabel>

                <div className="grid grid-cols-2 gap-5 mb-5">

                  <div className="flex flex-col">
                    <FieldLabel>Password</FieldLabel>
                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: 'Please input your password!' },
                        {
                          pattern: passRegex,
                          message: 'Min 8 chars, one uppercase, one number & one special character.',
                        },
                      ]}
                      hasFeedback
                    >
                      <Input.Password placeholder="Create a strong password" />
                    </Form.Item>
                  </div>

                  <div className="flex flex-col">
                    <FieldLabel>Confirm Password</FieldLabel>
                    <Form.Item
                      name="confirm"
                      dependencies={['password']}
                      hasFeedback
                      rules={[
                        { required: true, message: 'Please confirm your password!' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('Passwords do not match!'));
                          },
                        }),
                      ]}
                    >
                      <Input.Password placeholder="Repeat your password" />
                    </Form.Item>
                  </div>

                </div>

              </>
            )}

            {/* ── Actions ── */}
            <div className="border-t border-slate-100 mt-6 pt-6 flex items-center gap-3">
              <Button
                type="primary"
                htmlType="submit"
                className="!bg-blue-800 !border-none !rounded-xl !h-10 !px-7 !text-sm !font-semibold !tracking-wide !shadow-md hover:!bg-blue-900 hover:!-translate-y-px !transition-all !duration-150"
              >
                {edit ? 'Save Changes' : 'Register User'}
              </Button>
              <Button
                className="!rounded-xl !h-10 !px-7 !text-sm !font-medium !text-slate-500 !border !border-slate-200 !bg-white hover:!border-slate-300 hover:!text-slate-800 !transition-all !duration-150"
                onClick={() => navigate('/active-users')}
              >
                {edit ? 'Cancel' : 'Go Back'}
              </Button>
            </div>

          </Form>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}

export default CreateUser;